import { useAutocomplete } from "./providers/AutocompleteProvider.tsx";
import { Modal } from "./components/Modal/Modal";
import { Form } from "./components/Form/Form";
import { Products } from "./components/Products/Products";
import { CategoryMatches } from "./components/CategoryMatches/CategoryMatches";
import { InformationResults } from "./components/Information/InformationResults";

export function AppAutocomplete() {
	const { autocomplete, searchRef, panelRef } = useAutocomplete();

	const siteCode =
		typeof document !== "undefined"
			? document.body.dataset.site_code
			: undefined;

	return (
		<div className={`algoliaAutocomplete`} {...autocomplete.getRootProps({})}>
            <div className={"algoliaAutocomplete__layout"}>
                <header className={"algoliaAutocomplete__header"}>
                    <div className={"algoliaAutocomplete__controls"}>
                        <Form />
                    </div>
                </header>
                <Modal>
                    <div className="algoliaAutocomplete__wrapper">

                        <section
                            className="aa-PanelLayout algoliaAutocomplete__content"
                            ref={panelRef}
                            {...autocomplete.getPanelProps({})}
                        >

                            <div className="algoliaAutocomplete__categories">
                                <div className="algoliaAutocomplete__categoryMatches">
                                    <CategoryMatches />
                                </div>
                                {siteCode !== 'aewi' && <InformationResults />}
                            </div>

                            <div className="algoliaAutocomplete__results" ref={searchRef}>
                                <Products />
                            </div>
                        </section>
                    </div>
                </Modal>
            </div>
        </div>
	);
}
